import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { Config } from '@shared/configs/config';
import { map } from 'rxjs';

@Injectable()
export class AttachmentService extends BaseHttpService {
  constructor() {
    super();
  }

  uploadAttachment(data, queryParams: any = {}) {
    let str = Object.entries(queryParams || {})
      .map(([key, val]) => `${key}=${val}`)
      .join('&');

    const url = `${Config.API}/attachment${str?.length ? '?' + str : ''}`;
    return this.post(url, data, false, true);
  }

  uploadAttachmentWithProgress(data, queryParams: any = {}) {
    let str = Object.entries(queryParams || {})
      .map(([key, val]) => `${key}=${val}`)
      .join('&');

    const url = `${Config.API}/attachment${str?.length ? '?' + str : ''}`;
    return this.post(url, data, false, true, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((event.loaded / (event.total ?? 1)) * 100);
            return { progress };

          case HttpEventType.Response:
            return { progress: 100, result: event.body };

          default:
            return { progress: 0 };
        }
      })
    );
  }

  removeAttachment(id: number) {
    const url = `${Config.API}/attachment/${id}`;
    return this.delete(url);
  }

  removeAttachmentGroup(ids: number[]) {
    const url = `${Config.API}/attachment/bulk`;
    return this.delete(url, false, { params: { 'ids[]': ids } });
  }

  getAttachmentZip(files: string[]) {
    const query = new URLSearchParams();
    files.forEach((file, i) => query.append(`files[${i}]`, file));
    const getUrl = decodeURIComponent(query.toString());
    const url = `${Config.API}/attachment/zip?${getUrl}`;
    return this.getFileBlob(url, false);
  }

  restoreAttachment(id: number) {
    const url = `${Config.API}/attachment/${id}/restore`;
    return this.post(url, {}, false, true);
  }
}
